import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-10">
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-book-read-line text-xl" style={{ color: 'oklch(var(--primary-400))' }}></i>
              </div>
              <span className="font-heading text-lg font-bold text-background-50">073漫画网</span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed mb-4">
              专注于少年漫画在线免费阅读的中文漫画平台，提供蜜桃少年漫画等热门作品的在线阅读体验，随时随地开启你的漫画之旅。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-700 hover:bg-primary-500 text-background-300 hover:text-background-50 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-700 hover:bg-primary-500 text-background-300 hover:text-background-50 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-700 hover:bg-primary-500 text-background-300 hover:text-background-50 transition-colors cursor-pointer" aria-label="QQ">
                <i className="ri-qq-line text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-background-50 mb-4">热门分类</h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-background-50 mb-4">快速链接</h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">首页</Link></li>
              <li><Link to="/category/shaonian" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">少年漫画</Link></li>
              <li><Link to="/category/rexie" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">热血漫画</Link></li>
              <li><Link to="/category/qihuan" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">奇幻漫画</Link></li>
              <li><Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-background-50 mb-4">联系与声明</h4>
            <ul className="space-y-2.5">
              <li className="text-sm text-background-400">邮箱：hello@tangcruises.com</li>
              <li className="text-sm text-background-400">QQ群：88888888</li>
              <li className="text-sm text-background-400">本站所有漫画均来自互联网，仅供学习交流使用，请支持正版。</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-700/50 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; 2026 073漫画网 版权所有 | 蜜桃少年漫画在线免费阅读
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer">用户协议</a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer">隐私政策</a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer" rel="nofollow">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}